import { render, staticRenderFns } from "./MemberDetail2.vue?vue&type=template&id=488a46e3&scoped=true"
import script from "./MemberDetail2.vue?vue&type=script&lang=js"
export * from "./MemberDetail2.vue?vue&type=script&lang=js"
import style0 from "./MemberDetail2.vue?vue&type=style&index=0&id=488a46e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a46e3",
  null
  
)

export default component.exports